import { render } from "./NavAdminComponent.vue?vue&type=template&id=4fee981c"
import script from "./NavAdminComponent.vue?vue&type=script&lang=js"
export * from "./NavAdminComponent.vue?vue&type=script&lang=js"

import "./NavAdminComponent.vue?vue&type=style&index=0&id=4fee981c&lang=css"
script.render = render

export default script